import { stringLiteral } from "./const-array";
const mainOptions = [
    "cargoType",
    "cargoDescription",
    "cargoLoadmeter",
    "cargoOperationalCO2Emissions",
    "cargoTotalCO2Emissions",
    "pickupAddress",
    "pickupPostcode",
    "pickupCity",
    "pickupPostcodeCity",
    "pickupPlaceName",
    "pickupDate",
    "pickupDateAndCargoInvoiceRef",
    "pickupTime",
    "pickupDateTime",
    "pickupContactPerson",
    "pickupLoadingRef",
    "dropoffAddress",
    "dropoffPostcode",
    "dropoffCity",
    "dropoffPostcodeCity",
    "dropoffDate",
    "dropoffDateAndCargoInvoiceRef",
    "dropoffTime",
    "dropoffDateTime",
    "dropoffContactPerson",
    "dropoffLoadingRef",
    "pickupDropoffPostcode",
    "pickupDropoffCities",
    "pickupDropoffPlaceName",
    "pickupDropoffPlaceNameCity",
    "pickupDropoffPostcodeCities",
    "dropoffPlaceName",
    "pickupDropoffCitiesDropoffDate",
    "pickupDropoffDates",
    "pickupDropoffTime",
    "pickupDropoffDatesTime",
    "customerContactPerson",
    "cargoInvoiceRef",
    "cargoInvoiceRef2",
    "ourRef",
    "truckRegNo",
    "trailerRegNo",
    "driver",
    "consolidatedInvoiceRef",
    "allDriverNotes",
];
export const allStopsOptions = [
    "allStopsPlaceName",
    "allStopsAddress",
    "allStopsPostcode",
    "allStopsCity",
    "allStopsPostcodeCity",
    "allStopsDate",
    "allStopsTime",
    "allStopsDateTime",
    "allStopsContactPerson",
    "allStopsLoadingUnloadingRef",
    "allStopsContactPersonLoadingUnloadingRef",
    "allStopsLoadmeter",
    "allStopsActualWeight",
    "allStopsNumberOfUnits",
    "allDriverNotes",
];
const consolidatedInvoiceSortOptions = [
    "invoiceLinePickupDate",
    "invoiceLineDropoffDate",
];
const consolidatedInvoiceGroupingOptions = [
    "invoiceLineGroupingRouteRef",
    "invoiceLineGroupingTruckRegNo",
];
const optionsDeliveryDate = [
    "today",
    "firstPickup",
    "lastDropoff",
    "pickupDate",
    "dropoffDate",
];
const optionsInvoiceLinesPositioning = ["above", "below"];
export const allInvoiceTemplateOptions = [
    ...mainOptions,
    ...allStopsOptions,
    ...consolidatedInvoiceSortOptions,
    ...consolidatedInvoiceGroupingOptions,
    ...optionsInvoiceLinesPositioning,
    ...optionsDeliveryDate,
];
export const allInvoiceTemplateOptionsT = stringLiteral(allInvoiceTemplateOptions, "all invoice template options");
export const formBuilderSelectValuesMainT = stringLiteral(mainOptions, "allCargoOptions");
export const formBuilderSelectValuesInvoiceLinesSortT = stringLiteral(consolidatedInvoiceSortOptions, "consolidatedInvoiceSortOptions");
export const formBuilderSelectValuesInvoiceLinesGroupingT = stringLiteral(consolidatedInvoiceGroupingOptions, "invoiceLinesGrouping");
export const formBuilderSelectValuesInvoiceLinesPositioningT = stringLiteral(optionsInvoiceLinesPositioning, "invoiceLinesPositioning");
export const formBuilderSelectValuesInvoiceLinesT = formBuilderSelectValuesMainT;
export const formBuilderSelectValuesAllStopsT = stringLiteral(allStopsOptions, "allStops");
export const formBuilderSelectValuesPDFAttachmentsT = formBuilderSelectValuesInvoiceLinesT;
export const formBuilderSelectValuesDeliveryDateT = stringLiteral(optionsDeliveryDate, "deliveryDate");
//# sourceMappingURL=form-builder-select-values.js.map